import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass } from "vue"
import _imports_0 from '../../../../public/icons/landscape/CombinedShape.svg'
import _imports_1 from '../../../../public/icons/landscape/path.svg'
import _imports_2 from '../../../../public/icons/landscape/Group.svg'
import _imports_3 from '../../../../public/icons/landscape/validation-alert.svg'
import _imports_4 from '../../../../public/icons/landscape/validation-empty.svg'
import _imports_5 from '../../../../public/icons/landscape/due-soon.svg'


const _hoisted_1 = {
  key: 0,
  src: _imports_0,
  alt: ""
}
const _hoisted_2 = {
  key: 1,
  src: _imports_1,
  alt: ""
}
const _hoisted_3 = {
  key: 2,
  src: _imports_2,
  alt: ""
}
const _hoisted_4 = {
  key: 3,
  src: _imports_3,
  alt: ""
}
const _hoisted_5 = {
  key: 4,
  src: _imports_4,
  alt: ""
}
const _hoisted_6 = {
  key: 5,
  src: _imports_5,
  alt: ""
}
const _hoisted_7 = { class: "alm-bdg-title" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["alm-bdg-wrapper", { 'alm-bdg-border': _ctx.showBorder }])
  }, [
    _createElementVNode("span", {
      class: _normalizeClass(["alm-bdg", _ctx.badgeClass])
    }, [
      (_ctx.value === _ctx.STATUS.DRAFT)
        ? (_openBlock(), _createElementBlock("img", _hoisted_1))
        : (_ctx.value === _ctx.STATUS.DEPLOYING)
          ? (_openBlock(), _createElementBlock("img", _hoisted_2))
          : (_ctx.value === _ctx.STATUS.READY)
            ? (_openBlock(), _createElementBlock("img", _hoisted_3))
            : (_ctx.value === _ctx.STATUS.FAILED)
              ? (_openBlock(), _createElementBlock("img", _hoisted_4))
              : (_ctx.value === _ctx.STATUS.INCOMPLETE)
                ? (_openBlock(), _createElementBlock("img", _hoisted_5))
                : (_ctx.value === _ctx.STATUS.QUEUED)
                  ? (_openBlock(), _createElementBlock("img", _hoisted_6))
                  : _createCommentVNode("", true),
      _createElementVNode("span", _hoisted_7, _toDisplayString(_ctx.itemTitle.toUpperCase()), 1)
    ], 2)
  ], 2))
}